'use strict';
var __createBinding =
  (this && this.__createBinding) ||
  (Object.create
    ? function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        var desc = Object.getOwnPropertyDescriptor(m, k);
        if (
          !desc ||
          ('get' in desc ? !m.__esModule : desc.writable || desc.configurable)
        ) {
          desc = {
            enumerable: true,
            get: function () {
              return m[k];
            },
          };
        }
        Object.defineProperty(o, k2, desc);
      }
    : function (o, m, k, k2) {
        if (k2 === undefined) k2 = k;
        o[k2] = m[k];
      });
var __setModuleDefault =
  (this && this.__setModuleDefault) ||
  (Object.create
    ? function (o, v) {
        Object.defineProperty(o, 'default', { enumerable: true, value: v });
      }
    : function (o, v) {
        o['default'] = v;
      });
var __importStar =
  (this && this.__importStar) ||
  function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null)
      for (var k in mod)
        if (k !== 'default' && Object.prototype.hasOwnProperty.call(mod, k))
          __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
  };
var __awaiter =
  (this && this.__awaiter) ||
  function (thisArg, _arguments, P, generator) {
    function adopt(value) {
      return value instanceof P
        ? value
        : new P(function (resolve) {
            resolve(value);
          });
    }
    return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) {
        try {
          step(generator.next(value));
        } catch (e) {
          reject(e);
        }
      }
      function rejected(value) {
        try {
          step(generator['throw'](value));
        } catch (e) {
          reject(e);
        }
      }
      function step(result) {
        result.done
          ? resolve(result.value)
          : adopt(result.value).then(fulfilled, rejected);
      }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
  };
var __rest =
  (this && this.__rest) ||
  function (s, e) {
    var t = {};
    for (var p in s)
      if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (
          e.indexOf(p[i]) < 0 &&
          Object.prototype.propertyIsEnumerable.call(s, p[i])
        )
          t[p[i]] = s[p[i]];
      }
    return t;
  };
var __importDefault =
  (this && this.__importDefault) ||
  function (mod) {
    return mod && mod.__esModule ? mod : { default: mod };
  };
Object.defineProperty(exports, '__esModule', { value: true });
exports.StatusButton = void 0;
const react_1 = require('@emotion/react');
const react_2 = __importDefault(require('react'));
const styled_1 = __importDefault(require('@emotion/styled'));
const form_1 = __importStar(require('../contexts/form'));
const useStatusHandler_1 = __importDefault(
  require('../hooks/useStatusHandler')
);
const fade = (0, react_1.keyframes)`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;
const rotate = (0, react_1.keyframes)`
    0% {
        transform: translate(-50%, -50%) rotate(0deg);
    }

    100% {
        transform: translate(-50%, -50%) rotate(360deg);
    }
`;
const ButtonStyled = styled_1.default.button(
  () => (0, react_1.css)`
    position: relative;

    display: inline-block;

    line-height: 1em;

    cursor: pointer;

    transition: all 0.33s ease-in-out;

    > span {
      transition: all 0.3s;
      transition-delay: 0.3s;
    }
    &:after {
      position: absolute;
      top: 50%;
      left: 50%;

      display: inline-block;
      content: '';
    }
  `,
  ({ state }) =>
    state !== 'WAITING' &&
    state !== 'CHANGED' &&
    (0, react_1.css)`
      cursor: default;

      pointer-events: none;

      > span {
        opacity: 0;

        transition-delay: 0s;
      }
    `,
  ({ state }) =>
    state === 'PENDING' &&
    (0, react_1.css)`
      &:after {
        width: 0.5em;
        height: 0.5em;

        border: 3px solid rgba(255, 255, 255, 0.33);
        border-top-color: currentColor;

        border-radius: 50%;
        transform: translate(-50%, -75%) rotate(-45deg);

        animation: ${fade} 0.33s ease, ${rotate} 0.66s linear 0s infinite;
      }
    `,
  ({ state }) =>
    state === 'ERROR' &&
    (0, react_1.css)`
      &:after {
        width: 1em;
        height: 1em;

        background: linear-gradient(
            to bottom,
            transparent 44%,
            currentColor 44%,
            currentColor 56%,
            transparent 56%
          ),
          linear-gradient(
            to right,
            transparent 44%,
            currentColor 44%,
            currentColor 56%,
            transparent 56%
          );

        transform: translate(-50%, -50%) rotate(-45deg);

        animation: ${fade} 0.6s ease;
      }
    `,
  ({ state }) =>
    state === 'SUCCESS' &&
    (0, react_1.css)`
      &:after {
        width: 1em;
        height: 0.5em;

        border: 3px solid currentColor;
        border-top-width: 0;
        border-right-width: 0;

        transform: translate(-50%, -75%) rotate(-45deg);

        animation: ${fade} 0.6s ease;
      }
    `
);
function StatusButton(_a) {
  var {
      as,
      children,
      onClickOperation,
      stateCSS = {
        CHANGED: {},
        ERROR: { backgroundColor: '#dd335c' },
        PENDING: {},
        SUCCESS: {},
        WAITING: {},
      },
    } = _a,
    extraProps = __rest(_a, ['children', 'as', 'onClickOperation', 'stateCSS']);
  const { status } = (0, form_1.useInternalForm)();
  const disabled = status === 'PENDING' ? true : false;
  const changeStatus = (0, useStatusHandler_1.default)();
  let onClick = extraProps.onClick;
  if (onClickOperation) {
    onClick = e =>
      __awaiter(this, void 0, void 0, function* () {
        e.preventDefault();
        e.stopPropagation();
        if (extraProps.onClick) extraProps.onClick(e);
        changeStatus('PENDING');
        try {
          yield onClickOperation(e);
          changeStatus('SUCCESS');
        } catch (_b) {
          changeStatus('ERROR');
        }
      });
  }
  return react_2.default.createElement(
    ButtonStyled,
    Object.assign(
      {
        as: as,
        disabled: disabled,
        state: status,
        style: stateCSS[status],
        type: 'submit',
      },
      extraProps,
      { onClick: onClick }
    ),
    react_2.default.createElement('span', null, children)
  );
}
exports.StatusButton = StatusButton;
function SubmitButton(props) {
  let Wrapper = react_2.default.Fragment;
  if (props.onClickOperation) {
    Wrapper = function Store({ children }) {
      return react_2.default.createElement(
        form_1.default,
        { defaultData: {} },
        children
      );
    };
  }
  return react_2.default.createElement(
    Wrapper,
    null,
    react_2.default.createElement(StatusButton, Object.assign({}, props))
  );
}
exports.default = SubmitButton;
//# sourceMappingURL=SubmitButton.js.map
